export interface UploadDocument {
  folderName: string;
  subFolderName: string;
  fileName: string;
}
